exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputBox[data-v-5ffd7055]{width:590px;height:120px!important}", ""]);

// exports
